<template>
  <div class="MultichoicePopupPane">
    <div class="header">
      <div class="buttons">
        <BackButton v-if="goBack" class="backButton" @click="goBack()" />
        <CloseButton class="closeButton" @click="hidePopup('closed')" />
      </div>
      <slot name="header"></slot>
    </div>
    <div class="body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import BackButton from './BackButton.vue'
import CloseButton from '~/vue-components/shared/CloseButton.vue'

export default {
  components: {
    BackButton,
    CloseButton,
  },
  props: {
    goBack: Function,
    hidePopup: Function,
  },
}
</script>

<style scoped>

.MultichoicePopupPane {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  padding: var(--spacing-6) var(--spacing-7);
  background-color: var(--brand-color);
}

.buttons {
  display: flex;
  color: var(--text-color-white);
}

.closeButton {
  margin-left: auto;
  --main-color: var(--text-color-white);
  --hover-color: var(--text-color-white);
}

.body {
  flex-grow: 1;
  padding: var(--spacing-7) var(--spacing-7);
  background-color: var(--bg-color-white);
  overflow-y: auto;
}

@media (--screen-lg) {

  .MultichoicePopupPane {
    width: 25.75rem;
  }

  .header {
    border-radius: 5px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .body {
    border-width: thin;
    border-style: none solid;
    border-color: var(--hairline-color);
  }
}
</style>
